import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Add aria-selected to all options

class SelectCheck extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: this.props.options ? this.addOptionsProps(this.props.options) : [],
            active: false
        }
    }

    componentWillReceiveProps(nextProps) {
        const options = this.addOptionsProps(nextProps.options)
        if (this.props.options !== options) {
            this.setState({options});
        }
    }

    componentWillMount() {
        document.addEventListener('mousedown', this.handleClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick, false);
    }

    addOptionsProps = (optionsArg) => {
        const options = optionsArg.map((option, index) => {
            option.checked = false
            return option
        })
        return options;
    }

    handleClick = (e) => {
        if (this.node.contains(e.target)) { 
            return
        } else {
            this.setState({active: false});
        }
    }

    renderPlaceholderValue = () => {
        const selectedOptions = []
        this.state.options.forEach((option, index) => {
            if (option.checked) {
                selectedOptions.push(option)
            }
        })
        let placeholderValue = 'Select all that apply'
        if (selectedOptions.length) {
            placeholderValue = selectedOptions.map((option, index) => {
                return (
                    <span key={`selected${option}${index}`}>{(index > 0 ? ', ' : '' ) + (option.label)}</span>
                )
            })
        } else if (this.props.placeholder) {
            placeholderValue = this.props.placeholder
        }
        return placeholderValue;
    }
    
    toggleDropdown = () => {
        const activeState = this.state.active
        this.setState({active: !activeState})
    }

    toggleSelectAll = (bool) => {
        const options = this.state.options.map((option, index) => {
            option.checked = bool
            return option
        })
        this.setState({options}, () => {
            this.props.onChange(this.state.options);
        })
    }

    changeStateHandler = (index) => {
        const options = this.state.options
        const checkedState = options[index].checked
        options[index].checked = !checkedState
        this.setState({options}, () => {
            this.props.onChange(this.state.options);
        });
    }

    render() {
        const titleSimple = this.props.title.replace(/[^A-Za-z0-9_]/g,'').trim().toLowerCase();
        const listboxId = `listbox${titleSimple}`;
        return (
            <React.Fragment>
                <label htmlFor={listboxId}>{this.props.title}</label>
                <div
                    role="listbox"
                    tabIndex="0"
                    aria-activedescendant="listbox-1"
                    name={listboxId}
                    id={listboxId}
                    ref={node => this.node = node}
                >
                    <div onClick={this.toggleDropdown}>
                        {this.renderPlaceholderValue()}
                    </div>
                    <fieldset className={this.state.active ? 'show' : null}>
                        {this.props.selectAll ? (
                            <div className="row around-xs border-bottom" style={{cursor: 'default'}}>
                                <button className="btn-create btn-tertiary margin-r-0 margin-b-1" onClick={() => this.toggleSelectAll(true)}>Select All</button>
                                <button className="btn-delete btn-tertiary margin-r-0 margin-b-1" onClick={() => this.toggleSelectAll(false)}>Clear All</button>
                            </div>
                        ) : null}
                        { this.state.options.map( (option, index) => {
                            const optionId = `${listboxId}option${index}`
                            return (
                                <div
                                    key={optionId}
                                    role="option"
                                    aria-selected={option.checked}
                                    className={this.props.selectAll && index === 0 ? 'margin-t-2' : null}
                                >
                                    <label htmlFor={optionId} style={{width: '100%'}}>
                                        <input
                                            type="checkbox"
                                            id={optionId}
                                            name={optionId}
                                            value={option.value}
                                            onChange={(e) => {
                                                this.changeStateHandler(index);
                                            }}
                                            checked={option.checked}
                                        />
                                        {option.label}
                                    </label>
                                </div>
                            )
                        })}
                    </fieldset>
                </div>
            </React.Fragment>
        )
    }
}

SelectCheck.propTypes = {
    title: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        disabled: PropTypes.bool
    })).isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    selectAll: PropTypes.bool
}

SelectCheck.defaultProps = {
    title: '',
    selectAll: true
}

export default SelectCheck;


// // EXAMPLE //

// // Import the component
// import SelectCheck from '../../components/SelectCheck';

// selectCheckCallback = (options) => {
//     console.log('OPTIONS: ', options)
//     // Getting options back instead of event is better for the following reasons:
//     // When "Select All" is chosen the selectCallback function doesn't have to programtaically called for each option
//     // Which means one API call can be made from the parent component instead of one for each option
//     // The same logic applies for "Clear All"
// }

// // Define options object
// const selectCheckOptions = [
//     {
//         value: "opt1",
//         label: "Option1"
//     },{
//         value: "opt2",
//         label: "Option2"
//     },{
//         value: "opt3",
//         label: "Option3"
//     }
// ]

// // Render component
// <SelectCheck
//     title="Tester Select Checks"
//     options={selectCheckOptions}
//     onChange={this.selectCheckCallback}
// />

// // Optional Props:
// // placeholder (string) - visible only when no options are checked
// // selectAll (boolean) - default true - show select all and clear all options


// WEBPACK FOOTER //
// ./src/components/SelectCheck/index.js